import {PropsWithChildren} from 'react';
import {ReportFiltersLabelContainerStyled} from './index.styled';

export function ReportFiltersLabelContainer({children}: PropsWithChildren) {
	return <ReportFiltersLabelContainerStyled>{children}</ReportFiltersLabelContainerStyled>;
}
